import React from 'react'

const AppointmentDairy = () => {
  return (
    <div>AppointmentDairy</div>
  )
}

export default AppointmentDairy